import { Model } from '@/app/shared/models/model';

export class CobillingtimModel extends Model {
  public ServiceId!: string;
  public SubscriptionId!: string;
  public MSISDN!: string;
  public Description!: string;

  constructor(data: CobillingtimModel) {
    super();
    this.ServiceId = data.ServiceId || '';
    this.SubscriptionId = data.SubscriptionId || '';
    this.MSISDN = data.MSISDN || '';
    this.Description = data.Description || '';
  }
}
